import { FC } from 'react';

import { BucketImg } from '@shared/components/BucketImg';

interface Props {
  /** 저장 전 맞춘 사진의 로컬 URL(PortraitUploadField 크롭). 있으면 버킷 이미지보다 우선 */
  portraitSrc?: string;
  dpImage?: { url: string } | null;
}

//* 영정 액자 — 기본 헤더·테마 헤더 사진형 공용. 한쪽만 바꾸지 말 것.
//* - 11:14 영정을 100×128로 고정 + 얇은 흰 선·3px 안쪽 여백의 매트(시안의 흰 테두리·둥근 모서리 어휘)
//* - 폭을 고정하는 이유: 11:14가 아닌 옛 사진이 글자 칸을 좁히지 않게 object-cover로 자른다
//* - w400 축소본(WebP) 우선, 파생본 없는 옛 파일은 BucketImg가 raw로 폴백
const PORTRAIT_IMG_CLASS =
  'block h-[128px] w-[100px] rounded-[1px] bg-gradient-to-t from-gray-50 to-gray-400 object-cover';

export const ObituaryPortrait: FC<Props> = function ObituaryPortrait({
  portraitSrc,
  dpImage,
}) {
  const img = portraitSrc ? (
    <img className={PORTRAIT_IMG_CLASS} src={portraitSrc} alt="영정사진" />
  ) : dpImage ? (
    <BucketImg
      className={PORTRAIT_IMG_CLASS}
      value={dpImage.url}
      size="w400"
      alt="영정사진"
    />
  ) : null;
  return (
    img && (
      <div className="relative shrink-0 rounded-sm border border-white/80 p-[3px]">
        {img}
      </div>
    )
  );
};
